module.exports = __webpack_public_path__ + "static/media/avenir-next-thin.d0735f89.eot";